import React, { useMemo } from 'react';
import { FormBuilder } from 'new/components/settings/VendorBuilder/FormControlBuilder';

interface HMACFieldsProps {
  index: number;
}

const hmacFields = (index) => [
  {
    type: 'text',
    name: `auth_templates[${index}].config["hmac.api.key"]`,
    label: (
      <>
        HMAC: API Key <code>auth_templates[{index}].config["hmac.api.key"]</code>
      </>
    ),

    description:
      'Enter the API key that will be used to sign requests. This is provided by the API vendor.',
  },
  {
    type: 'text',
    name: `auth_templates[${index}].config["hmac.api.secret"]`,
    label: (
      <>
        HMAC: API Secret <code>auth_templates[{index}].config["hmac.api.secret"]`</code>
      </>
    ),
    description:
      'API vendors often require an API secret to also be used for HMAC signature authentication. Check the vendor API documentation for more information.',
  },
  {
    type: 'text',
    multiline: true,
    name: `auth_templates[${index}].config["hmac.func"]`,
    label: (
      <>
        HMAC: Signature Generator Function <code>auth_templates[{index}].config["hmac.func"]</code>
      </>
    ),
    description:
      'Enter the signature generator function that will generate the appropriate signature for each request. We currently support the Base64-Encoded Scala function for generating HMAC signatures.',
  },
];

export const HMACFields = (props: HMACFieldsProps) => {
  const fields = useMemo(() => hmacFields(props.index), [props.index]);
  return <FormBuilder fields={fields} />;
};
